import * as React from "react";

import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { Tab, TabBadge, TabBar, TabSize } from "azure-devops-ui/Tabs";
import { InlineKeywordFilterBarItem } from "azure-devops-ui/TextFilterBarItem";
import { Filter, IFilter } from "azure-devops-ui/Utilities/Filter";

export default class SimpleTabBarWithIconsExample extends React.Component<{}> {
    private selectedTabId: ObservableValue<string>;
    private filter: IFilter;

    constructor(props: {}) {
        super(props);
        this.selectedTabId = new ObservableValue("tab2");
        this.filter = new Filter();
    }

    public render() {
        return (
            <TabBar
                onSelectedTabChanged={this.onSelectedTabChanged}
                selectedTabId={this.selectedTabId}
                tabSize={TabSize.Tall}
                renderAdditionalContent={this.onRenderFilterBar}
            >
                <Tab name="Tab 1" id="tab1" iconProps={{ iconName: "Home" }} />
                <Tab name="Tab 2" id="tab2" badgeCount={43} />
                <Tab name="Tab 3" id="tab3" url={"http://bing.com"} badgeCount={12345678} />
                <Tab name="Tab 4" id="tab4" renderBadge={() => <TabBadge>50+</TabBadge>} />
            </TabBar>
        );
    }

    private onSelectedTabChanged = (newTabId: string) => {
        this.selectedTabId.value = newTabId;
    };

    private onRenderFilterBar = () => {
        return <InlineKeywordFilterBarItem filter={this.filter} filterItemKey="keyword" />;
    };
}
